module.exports = __webpack_public_path__ + "img/18_18.9d311aef.png";